import PropTypes from 'prop-types';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var ImageSelectorLayout;
(function (ImageSelectorLayout) {
    ImageSelectorLayout["GRID"] = "grid";
    ImageSelectorLayout["LIST"] = "list";
})(ImageSelectorLayout || (ImageSelectorLayout = {}));
var propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
        imgUrl: PropTypes.string.isRequired,
        imgAlt: PropTypes.string.isRequired,
        isCover: PropTypes.bool.isRequired,
        customActions: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            iconName: PropTypes.string.isRequired,
            iconAlt: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            className: PropTypes.string,
        })),
    })).isRequired,
    className: PropTypes.string,
    layout: PropTypes.oneOf(['grid', 'list']),
    onAddImages: PropTypes.func.isRequired,
    onRemoveImage: PropTypes.func.isRequired,
    onCropImage: PropTypes.func.isRequired,
    onCoverImage: PropTypes.func.isRequired,
    onShowMoreImages: PropTypes.func.isRequired,
    pickerText: PropTypes.string,
    accepted: PropTypes.string,
    onFilesRejected: PropTypes.func,
};
var defaultProps = {
    images: [],
    layout: 'grid',
    pickerText: 'Browse or drop image',
    accepted: 'image/',
};

export { ImageSelectorLayout, defaultProps, propTypes };
